import { Organisation } from 'api'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { AxeDetail } from 'selectors/axeSelectors'
import { createFilteredOrganisationsSelector } from 'selectors/organisationSelectors'
import { ComboboxProps } from 'view/components/options'
import { OrganisationsCombobox } from 'view/shared/entity/OrganisationsCombobox'
import { createOrganisationFiltersForAxeCounterpartySelector } from '../selectors/organisationFiltersForAxeCounterpartySelector'

export interface AxeCounterpartyComboboxProps extends ComboboxProps<Organisation, string> {
  axeDetail: AxeDetail
}

export const AxeCounterpartyCombobox = connect(
  createStructuredSelector({
    organisations: createFilteredOrganisationsSelector<AxeCounterpartyComboboxProps>(
      createOrganisationFiltersForAxeCounterpartySelector((_, props) => props.axeDetail)
    )
  }),
  null,
  null,
  { forwardRef: true }
)(OrganisationsCombobox)
